import {
    type OfferRequestSegment,
    type PartnerCockpitOfferRequestsPage,
    partnerCockpitOfferRequestsPageSchema,
} from '@houzy/schemas/partner-cockpit/offer-requests';

import { apiRequest } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';
import type { OfferRequestFiltersValue, OfferRequestSortKey } from '../types';

export type OfferRequestsQueryParams = {
    segment: OfferRequestSegment;
    start: number;
    pageSize: number;
    sort: OfferRequestSortKey;
    filters: OfferRequestFiltersValue;
};

function buildQueryString({ segment, start, pageSize, sort, filters }: OfferRequestsQueryParams): string {
    const params = new URLSearchParams();
    params.set('segment', segment);
    params.set('start', String(start));
    params.set('pageSize', String(pageSize));
    params.set('sort', sort);
    if (filters.search.trim()) {
        params.set('search', filters.search.trim());
    }
    if (filters.dateFrom) {
        params.set('dateFrom', filters.dateFrom);
    }
    if (filters.dateTo) {
        params.set('dateTo', filters.dateTo);
    }
    const arrayFilters: [string, readonly (string | number)[]][] = [
        ['timingGroups', filters.timingGroups],
        ['projectSizes', filters.projectSizes],
        ['credits', filters.credits],
        ['languages', filters.languages],
        ['buildingTypes', filters.buildingTypes],
        ['statuses', filters.statuses],
    ];
    for (const [key, values] of arrayFilters) {
        if (values.length > 0) {
            params.set(key, values.join(','));
        }
    }
    return params.toString();
}

export async function fetchOfferRequests(
    query: OfferRequestsQueryParams,
    signal?: AbortSignal,
): Promise<PartnerCockpitOfferRequestsPage> {
    return apiRequest(partnerCockpitApiPath(`offer-requests?${buildQueryString(query)}`), {
        signal,
        responseSchema: partnerCockpitOfferRequestsPageSchema,
    });
}
